export const getBaseApiUrl = (): string => window.config.storebrandApiUrl;
